import React, { useState, useRef } from 'react';

// Light bot protection for the public forms (no effect on real visitors):
//  - a hidden "honeypot" field that people never see or fill, but simple bots do
//  - a minimum time on the page before a submit counts as human
// This is a front-end filter only. Real protection (CAPTCHA verification, rate limiting)
// must also be enforced by the backend.
const MIN_SECONDS_BEFORE_SUBMIT = 2;

export const useBotTrap = () => {
  const [honeypot, setHoneypot] = useState('');
  const startedAt = useRef(Date.now());
  const looksLikeBot = () =>
    honeypot !== '' || Date.now() - startedAt.current < MIN_SECONDS_BEFORE_SUBMIT * 1000;
  return { honeypot, setHoneypot, looksLikeBot };
};

const BotTrap = ({ trap }) => (
  <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
    <label htmlFor="contact_extra">Leave this field empty</label>
    <input
      id="contact_extra"
      name="contact_extra"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={trap.honeypot}
      onChange={(e) => trap.setHoneypot(e.target.value)}
    />
  </div>
);

export default BotTrap;
